import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import axios from '../utils/posAxios';
import { MdDone, MdClear } from 'react-icons/md';
import StorageService from '../services/StorageService';
import moment from 'moment-timezone';
import update from 'immutability-helper';

class CrmCampaignForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      customerList: [],
      customerDataList: [],
      broadcast_id: '',
      broadcast_subject: '',
      broadcast_date: '',
      categoryList: [],
      age: 'All',
      count: 0,
      category: 'All',
      type: 'All',
      dataList: [],
      selectedCategory: [],
      selectedType: [],
      customdatafilter: '',
      tagfilter: '',
      fileUrl: [],
      reply_email: '',
    };
  }

  componentDidMount() {
    this.getCustomer();
    //this.getCustomerData();
    this.getCategoryList();
    //this.getDataType();
    if (this.props.data.isEdit) {
      let data = this.props.data;
      this.setState({
        isEdit: data.isEdit,
        broadcast_id: data.broadcast_id,
        broadcast_subject: data.broadcast_subject,
        broadcast_date: data.broadcast_date,
        category: data.category,
        customdatafilter: data.customdatafilter,
        tagfilter: data.tagfilter,
        reply_email: data.reply_email,
      });
    } else {
      const user = StorageService.getSession('user_info');
      this.setState({
        reply_email: user.email,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  ageHandler = event => {
    const { name, value } = event.target;
    let count =
      value == 'All'
        ? this.state.customerList.length
        : this.state.customerList.filter(x => x.age < value).length;

    this.setState({
      [name]: value,
      count: count,
    });
  };

  categoryHandler = event => {
    const { name, value } = event.target;
    let categoryCount;
    let typeCount;
    let categoryArray = [...this.state.selectedCategory];
    let typeArray = [...this.state.selectedType];

    if (name === 'category') {
      categoryCount =
        value == 'All'
          ? this.state.customerList.length
          : this.state.customerList.filter(x => x.category === value).length;

      categoryArray =
        value == 'All'
          ? this.state.customerList
          : this.state.customerList.filter(x => x.category === value);
    }

    if (name === 'type') {
      typeCount =
        value == 'All'
          ? this.state.customerDataList.length
          : this.state.customerDataList.filter(x => x.brand === value).length;

      typeArray =
        value == 'All'
          ? this.state.customerDataList
          : this.state.customerDataList.filter(x => x.brand === value);
    }

    let array = [...categoryArray, ...typeArray];
    let carrray = array.map(q => q.customer_id);
    let unique = carrray.filter((q, idx) => carrray.indexOf(q) === idx);
    console.log('CrmCampaignForm -> unique', unique);

    this.setState({
      [name]: value,
      count: unique.length,
      selectedCategory: categoryArray,
      selectedType: typeArray,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const zo_url = process.env.REACT_APP_API_URL;
    if (this.state.isEdit) {
      this.editData(user, comp, zo_url);
    } else {
      this.addData(user, comp, zo_url);
    }
  };

  getCategoryList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3004/v1/customer/category', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            categoryList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  getCustomer = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3004/v1/customer', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        if (result.data.length > 0) {
          for (let i of result.data) {
            let dob = moment(i.dob, 'YYYY-MM-DD').tz('Asia/Singapore');
            let today = moment().tz('Asia/Singapore');
            let age = today.diff(dob, 'years');
            i.age = age;
          }
        }

        if (this._isMounted) {
          this.setState({
            customerList: result.data,
            selectedCategory: result.data,
            count: result.data.length,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  getCustomerData = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3004/v1/customer/data', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        if (this._isMounted) {
          this.setState({
            customerDataList: result.data,
            selectedType: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  addData(user, comp, url) {
    const data = {
      session_key: user.session_key,
      company_id: comp.CompanyID,
      broadcast_subject: this.state.broadcast_subject,
      broadcast_date: this.state.broadcast_date,
      category: this.state.category,
      customdatafilter: this.state.customdatafilter,
      tagfilter: this.state.tagfilter,
      count: this.state.count,
      reply_email: this.state.reply_email,
      fileUrl: [],
    };
    axios
      .post(url + ':3001/v1/broadcast/Create', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'New Broadcast added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  editData(user, comp, url) {
    const data = {
      session_key: user.session_key,
      broadcast_id: this.state.broadcast_id,
      broadcast_subject: this.state.broadcast_subject,
      broadcast_date: this.state.broadcast_date,
      category: this.state.category,
      customdatafilter: this.state.customdatafilter,
      tagfilter: this.state.tagfilter,
      count: this.state.count,
      reply_email: this.state.reply_email,
      fileUrl: [],
    };
    axios
      .post(url + ':3001/v1/broadcast/Edit', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Broadcast updated successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  getDataType = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3004/v1/customer/data', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          let unique = result.data.map(q => q.brand);
          let data = unique.filter((q, idx) => unique.indexOf(q) === idx);

          this.setState({
            dataList: data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  render() {
    const { broadcast_subject, broadcast_date, age, count } = this.state;
    const detail = (
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>Broadcast Subject</Label>
            <Input
              type="text"
              name="broadcast_subject"
              value={broadcast_subject}
              onChange={this.changeHandler}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Broadcast Date</Label>
            <Input
              type="date"
              name="broadcast_date"
              value={broadcast_date}
              onChange={this.changeHandler}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Category</Label>
            <Input
              type="select"
              name="category"
              value={this.state.category}
              onChange={this.changeHandler}
            >
              <option value="All">ALL</option>
              {this.state.categoryList.map(item => {
                return (
                  <option key={item.id} value={item.name}>
                    {item.name}
                  </option>
                );
              })}
            </Input>
          </FormGroup>

          <FormGroup>
            <Label>Custom Data Filter</Label>
            <Input
              type="text"
              name="customdatafilter"
              value={this.state.customdatafilter}
              onChange={this.changeHandler}
            />
          </FormGroup>

          <FormGroup>
            <Label>Tag Filter</Label>
            <Input
              type="text"
              name="tagfilter"
              value={this.state.tagfilter}
              onChange={this.changeHandler}
            />
          </FormGroup>

          <FormGroup>
            <Label>Reply Email</Label>
            <Input
              type="email"
              name="reply_email"
              value={this.state.reply_email}
              onChange={this.changeHandler}
              required
            />
          </FormGroup>

          {/* <FormGroup>
            <Label>Type</Label>
            <Input
              type="select"
              name="type"
              value={this.state.type}
              onChange={this.categoryHandler}
            >
              <option value="All">ALL</option>
              {this.state.dataList.map((item, index) => {
                return (
                  <option key={index} value={item}>
                    {item}
                  </option>
                );
              })}
            </Input>
          </FormGroup> */}
          {/* <FormGroup>
            <Label>Age</Label>
            <Input
              type="text"
              name="age"
              value={age}
              onChange={this.ageHandler}
            />
          </FormGroup> */}
          {/* <FormGroup>
            <Label>Count</Label>
            <Input type="text" name="count" value={count} readOnly />
          </FormGroup> */}
        </Col>
      </Row>
    );

    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Campaign Detail
        </ModalHeader>
        <ModalBody>{detail}</ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default CrmCampaignForm;
